import { get } from 'lodash-es';
export const hasReportData = (patient, key) => {
    const timestamp = get(patient, `${key}[0].reportData.reportTimestamp`);
    return !!timestamp;
};
